import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Table,
  TableCell,
  TableRow,
  Tabs,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { SALE_CONFIG } from "../../config";
import { MobileDatePicker } from "@mui/x-date-pickers";
import SaleContext from "../../services/saleApi";
import api from "../../../../api/api";
import { AGENT_CONFIG } from "../../../agent/config";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faFloppyDisk,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import ConfirmPrint from "../component/ConfirmPrint";
import DiscardDialog from "../component/DiscardDialog";
import {
  addSaleDois,
  getCustomersList,
  getItemDiscardBalanceList,
  getLotItemList,
  getReserveCustomer,
  getSaleItemList,
} from "../../services/api";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ height: "405px", overflowY: "auto" }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "5px" }}>{children}</Box>}
    </div>
  );
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  background: "#fff !important",
  border: "none",
}));
const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : ""
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function ItemSale() {
  const { profile, loading } = useSelector((state) => state.profile);

  const [keyword, setkeyword] = useState("");
  const [keyword2, setkeyword2] = useState("");
  const [DoiNo, setDoiNo] = useState();
  const [open, setOpen] = useState(false);
  const [openDiscard, setOpenDiscard] = useState(false);
  const [openSubmit, setOpenSubmit] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const [noneDeliveryPrice, setNoneDeliveryPrice] = useState(false);
  const [ReserveNo, setReserveNo] = useState("all");
  const [customerText, setCustomerText] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customerError, setCustomerError] = useState(false);
  const [StockItems, setStockItems] = useState([]);
  const [customerData, setCustomerData] = useState();
  const [Remark, setRemark] = useState("");
  const [tabSelected, setTabSelected] = useState("ขายเมล็ดพันธุ์");
  const [ReserveCustomer, setReserveCustomer] = useState();
  const [ItemsReserveCustomer, setItemsReserveCustomer] = useState();
  const [LotSale, setLotSale] = useState();
  const [Item, setItem] = useState([]);
  const [selectItem, setselectItem] = useState();
  const [dialogData, setDialogData] = useState();
  const [dialogDatafilter, setDialogDatafilter] = useState();
  const [loadingDialog, setLoadingDialog] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingDownloadDoi, setLoadingDownloadDoi] = useState(false);
  const [itemDialog, setItemDialog] = useState([]);
  const [CustomerName, setCustomerName] = useState();
  const [CustomerNo, setCustomerNo] = useState();
  const [CustomerTypeName, setCustomerTypeName] = useState();
  const [Province, setProvince] = useState();
  const [District, setDistrict] = useState();
  const [SubDistrict, setSubDistrict] = useState();
  const [Zipcode, setZipcode] = useState();
  const [Tel, setTel] = useState();
  const [Fax, setFax] = useState();
  const [Moo, setMoo] = useState();
  const [Address, setAddress] = useState();
  const [HouseNumber, setHouseNumber] = useState();
  const [AddressNational, setAddressNational] = useState();
  const [stockNormalItem, setStockNormalItem] = useState([]);
  const [filterNormalItem, setFilterNormalItem] = useState([]);
  const [stockPromotionItems, setStockPromotionItems] = useState([]);
  const [filterPromotionItems, setFilterPromotionItems] = useState([]);
  const [stockReserveItems, setStockReserveItems] = useState([]);
  const [filterReserveItems, setFilterReserveItems] = useState([]);
  const [noneDiscount, setNoneDiscount] = useState(false);
  const [SaleType, setSaleType] = useState("ราคาปกติ");
  const [PaymentType, setPaymentType] = useState("ขายสด");
  const [PaymentRemark, setPaymentRemark] = useState("");
  const [DeliveryDocNo, setDeliveryDocNo] = useState("");
  const [DeliveryDocNoError, setDeliveryDocNoError] = useState("");
  const [DeliveryDocDate, setDeliveryDocDate] = useState();
  const [checkedDeliveryDocNo, setCheckedDeliveryDocNo] = useState(false);
  const [checkedDeliveryDocDate, setCheckedDeliveryDocDate] = useState(false);
  const [DeliveryDocDateError, setDeliveryDocDateError] = useState();
  const [InspectionDocNo, setInspectionDocNo] = useState("");
  const [checkedInspectionDocNo, setCheckedInspectionDocNo] = useState(false);
  const [checkedInspectionDocDate, setCheckedInspectionDocDate] =
    useState(false);
  const [InspectionDocNoError, setInspectionDocNoError] = useState("");
  const [InspectionDocDate, setInspectionDocDate] = useState();
  const [InspectionDocDateError, setInspectionDocDateError] = useState();
  const [StockDiscardItems, setStockDiscardItems] = useState([]);
  const [filterStockDiscardItems, setFilterStockDiscardItems] = useState([]);
  const [DiscardItems, setDiscardItems] = useState();

  // const [test, settest] = useState([]);
  const handleClickOpen = (x) => {
    setOpenDiscard(true);
    setDiscardItems(x);
  };
  const handleCloseOpen = () => {
    setOpenDiscard(false);
    setDiscardItems([]);
  };
  const checkSelectOriginal = (item, _lot) => {
    const adaptLots = _lot;

    const itemNo = adaptLots[0]?.ItemNo?.ItemNo;
    const findMaster =
      Item.length > 0
        ? Item?.find((x) => x.ItemNo === itemNo && x.seq === item?.seq)
        : null;
    if (findMaster) {
      for (const c of adaptLots) {
        const findLots =
          findMaster.lots && findMaster.lots.length > 0
            ? findMaster.lots.find((x) => x.Lot === c.Lot)
            : null;

        if (findLots && findLots.Lot === c.Lot) {
          c.Qty = findLots.Qty;
          // c.Balance = c.Balance - findLots.Qty;
          c.selected = true;
        }
      }
    }

    return adaptLots;
  };

  async function selectedItem(item) {
    if (
      (itemDialog.some((e) => e.Option2.includes("หลัก")) &&
        !item.Option2.includes("หลัก")) ||
      (itemDialog?.some((e) => !e.Option2.includes("หลัก")) &&
        item.Option2.includes("หลัก"))
    ) {
      Swal.fire({
        title: "ชั้นพันธุ์หลักไม่สามารถจำหน่ายรวมกับชั้นพันธุ์อื่นได้",
        icon: "warning",
      });
    } else {
      setLoadingSelect(true);
      // item.loading = true;
      setLoadingDialog(true);
      let _lot = [];
      const data = await getLotItemList(item?.ItemNo);
      if (tabSelected === "ขายเฉพาะกิจ") {
        _lot = data.PromotionLots;
      } else {
        _lot = data.NormalLots;
        if (item.Year) {
          _lot = _lot.filter((lot) => lot.Lot.slice(6, 8) === item.Year);
        }
      }

      _lot = checkSelectOriginal(item, _lot);

      setLoadingSelect(false);
      if (_lot.length === 0) {
        Swal.fire({
          title: "ไม่พบรายการล็อตในระบบ",
          icon: "warning",
        });
      } else {
        setDialogDatafilter({
          lot: _lot?.map((x) => {
            return {
              ...x,
              Qty:
                +itemDialog
                  ?.find((y) => y?.ItemNo === x?.ItemNo?.ItemNo)
                  ?.lots?.find((z) => z?.Lot === x?.Lot)
                  ?.Qty?.toString()
                  .replaceAll(",", "") || 0,
            };
          }),
          item: item,
          customerTypeNo: customerData?.CustomerTypeNo?.CustomerTypeNo,
          stockItemSelected: Item,
        });
        setDialogData({
          lot: _lot?.map((x) => {
            return {
              ...x,
              Qty:
                +itemDialog
                  ?.find((y) => y?.ItemNo === x?.ItemNo?.ItemNo)
                  ?.lots?.find((z) => z?.Lot === x?.Lot)
                  ?.Qty?.toString()
                  .replaceAll(",", "") || 0,
            };
          }),
          item: item,
          customerTypeNo: customerData?.CustomerTypeNo?.CustomerTypeNo,
          stockItemSelected: Item,
        });
        setOpen(true);
        setLoadingDialog(false);
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
    setkeyword2("");
    if (Item.length > 0) {
      if (dialogData?.item?.ReserveNo) {
        detectItemsReserves(dialogData?.item, Item);
      } else if (dialogData?.item?.promotion) {
        detectItemsPromotion(Item);
      } else {
        detectItems(Item);
      }
    }
  };
  const handleCloseSubmit = () => {
    setOpenSubmit(false);
  };

  const detectItems = (_lots) => {
    const itemNo = _lots[0]?.ItemNo?.ItemNo;
    const findMaster = stockNormalItem.find((x) => x.ItemNo === itemNo);
    const findItemSelected = itemDialog.find((x) => x.ItemNo === itemNo);
    const sumQty = _lots.map((x) => x.Qty).reduce((p, n) => p + n, 0);
    if (findItemSelected) {
      findItemSelected.lots = _lots;
    } else {
      itemDialog.push({
        ...findMaster,
        lots: _lots,
      });
    }

    setItem([]);
    // findMaster.QtySale = +sumQty;
    // findMaster.Balance = findMaster.Balance - +sumQty;
  };

  const detectItemsPromotion = (_lots) => {
    const itemNo = _lots[0]?.ItemNo?.ItemNo;
    const findMaster = stockPromotionItems.find((x) => x.ItemNo === itemNo);
    const findItemSelected = itemDialog.find((x) => x.ItemNo === itemNo);
    const sumQty = _lots.map((x) => x.Qty).reduce((p, n) => p + n, 0);
    if (findItemSelected) {
      findItemSelected.lots = _lots;
    } else {
      itemDialog.push({
        ...findMaster,
        lots: _lots,
      });
    }
    setItem([]);
    // findMaster.QtySale = +sumQty;
    // findMaster.Balance = findMaster.Balance - +sumQty;
  };

  const detectItemsReserves = (item, _lots) => {
    const itemNo = _lots[0]?.ItemNo?.ItemNo;
    const findMasterReserves =
      stockReserveItems.length > 0
        ? stockReserveItems.find(
            (x) => x.ItemNo === itemNo && x.seq === item?.seq
          )
        : null;

    const findItemSelected = itemDialog?.find(
      (x) => x.ItemNo === itemNo && x.seq === item?.seq
    );
    const sumQty = _lots.map((x) => x.Qty).reduce((p, n) => p + n, 0);
    if (findItemSelected) {
      findItemSelected.lots = _lots;
    } else {
      itemDialog.push({
        ...findMasterReserves,
        lots: _lots,
      });
    }
    setItem([]);
  };

  const getCustomers = async (keyword) => {
    const res = await getCustomersList(keyword);

    if (res) {
      setCustomers(res);
    }
  };
  useEffect(() => {
    if (customerText?.length > 1) {
      getCustomers(customerText);
    }
  }, [customerText]);

  async function LoadStockItems() {
    const BranchNo = profile?.BranchNo?.BranchNo;
    const data = await getSaleItemList();

    if (data?.NormalItems?.length > 0) {
      let seq = 0;
      data.NormalItems.forEach((x) => {
        x.seq = seq + 1;
      });
      const _normalItem = data.NormalItems;
      setStockNormalItem(_normalItem);
      setFilterNormalItem(_normalItem);
    }

    if (data?.PromotionItems?.length > 0) {
      let seq = 0;
      data.PromotionItems.forEach((x) => {
        x.promotion = true;
        x.seq = seq + 1;
      });

      const _promotion = data.PromotionItems;

      setFilterPromotionItems(_promotion);
      setStockPromotionItems(_promotion);
    }
    if (data?.DiscardItems?.length > 0) {
      let seq = 0;
      data.DiscardItems.forEach((x) => {
        x.discard = true;
        x.seq = seq + 1;
      });

      const _discard = data.DiscardItems;
      setStockDiscardItems(_discard);
      setFilterStockDiscardItems(_discard);
    }
    if (data?.DiscardItems?.length === 0) {
      setStockDiscardItems([]);
      setFilterStockDiscardItems([]);
    }
  }
  // async function LoadStockDiscardItems() {
  //     const BranchNo = profile?.BranchNo?.BranchNo;
  //     const res = await getItemDiscardBalanceList()

  //     setStockDiscardItems(res)
  //     setFilterStockDiscardItems(res)

  // }

  async function LoadItemsReserve(ReserveNo) {
    const isReserveCenter = ReserveNo.includes("-");
    const CustomerNo = customerData?.CustomerNo;

    const res = await getReserveCustomer(CustomerNo, ReserveNo);
    const _reserve = [];
    await LoadStockItems();
    let i = 0;
    for (const x of res) {
      const findStockMaster = stockNormalItem.find(
        (c) => c.ItemNo === x.ItemNo
      );

      if (findStockMaster) {
        _reserve.push({
          ...findStockMaster,
          // QtySale: 0,
          Balance: x ? x?.Balance : 0,
          seq: i++,
          ReserveNo: ReserveNo,
          ReservedQty: x.ReservedQty,
          ReserveDetailCode: x?.ReserveDetailCode ? x?.ReserveDetailCode : null,
          SubDistrict: x?.SubDistrict ? x?.SubDistrict : null,
          Year: x?.Year ? x?.Year : null,
          reserveCenter: isReserveCenter,
        });
      } else {
        _reserve.push({
          ...x,
          Balance: 0,
          seq: i++,
          ReserveNo: ReserveNo,
          ReservedQty: x.ReservedQty,
          ReserveDetailCode: x?.ReserveDetailCode ? x?.ReserveDetailCode : null,
          SubDistrict: x?.SubDistrict ? x?.SubDistrict : null,
          Year: x?.Year ? x?.Year : null,
          reserveCenter: isReserveCenter,
        });
      }
    }
    // for (const x of data) {
    //     stockNormalItem = stockNormalItem.filter(c => c.ItemNo !== x.ItemNo);
    //     filterNormalItem = stockNormalItem;
    // }

    // this.stockItemSelected = [];
    setStockReserveItems(_reserve);
    setFilterReserveItems(_reserve);
  }

  // const totalPrice = Item?.map((z) => +z.SalePrice * +z.Qty).reduce((prev, curr) => prev + curr, 0) || 0
  const totalPrice = () => {
    let sum = 0;
    itemDialog.forEach((x) => {
      if (x.lots && x.lots.length > 0) {
        sum += x.lots
          .map((z) => +z.SalePrice * +z?.Qty.toString().replaceAll(",", ""))
          .reduce((prev, curr) => prev + curr, 0);
      }
    });

    return sum || 0;
  };

  const totalVat = () => {
    let sum = 0;
    sum = (totalPrice * 7) / 100;
    return sum || 0;
  };

  const totalDelivery = () => {
    let sum = 0;

    itemDialog?.forEach((x) => {
      if (x.lots && x.lots.length > 0) {
        if (noneDeliveryPrice || x.reserveCenter) {
          sum += x.lots
            .map((z) => +z.Qty.toString().replaceAll(",", ""))
            .reduce((prev, curr) => prev + curr, 0);
        }
      }
    });

    return sum || 0;
  };
  // const totalDelivery = Item?.map((z) => +z.Qty).reduce((prev, curr) => prev + curr, 0) || 0

  // () => {
  //     let sum = 0;

  //     Item.forEach(x => {
  //         if (x.lots && x.lots.length > 0) {
  //             x.lots.forEach(c => {
  //                 if (this.form.get('noneDeliveryPrice').value || x.reserveCenter) {
  //                     sum += +c.Qty;
  //                 }

  //             })
  //         }

  //     })

  //     return sum || 0;
  // }

  const totalQty = (items) => {
    let total = 0;
    if (items.lots && items.lots.length > 0) {
      total = items?.lots
        ?.map((z) => +z.SalePrice * +z.Qty.toString().replaceAll(",", ""))
        .reduce((prev, curr) => prev + curr, 0);
    }

    return total;
  };
  let discountPercent = 0;
  const Discount = () => {
    let discount = 0;
    const type = customerData?.CustomerTypeNo;
    if (type) {
      if (totalPrice() >= type?.DiscountMinimum_1) {
        discount = (type?.DiscountPercent_1 * totalPrice()) / 100;
        discountPercent = type?.DiscountPercent_1;
      } else if (totalPrice() >= type?.DiscountMinimum_2) {
        discount = (type?.DiscountPercent_2 * totalPrice()) / 100;
        discountPercent = type?.DiscountPercent_2;
      } else {
        discountPercent = 0;
      }

      if (
        noneDiscount ||
        tabSelected === "ขายเฉพาะกิจ" ||
        tabSelected === "ขายเมล็ดพันธุ์คัดออก" ||
        itemDialog?.some((e) => e.Option2?.includes("หลัก"))
      ) {
        discount = 0;
        discountPercent = 0;
      }
    }

    return customerData ? discount : 0;
  };
  const NetPrice = () => {
    let sum = 0;
    sum = totalPrice() + totalDelivery() - Discount();

    return sum || 0;
  };

  const deleteLots = (item, lot) => {
    const findMaster =
      stockNormalItem.length > 0
        ? stockNormalItem.find((x) => x.ItemNo === item.ItemNo)
        : null;
    const findMasterReserves =
      stockReserveItems.length > 0
        ? stockReserveItems.find((x) => x.ItemNo === item.ItemNo)
        : null;

    if (item.lots.length === 1) {
      const i = itemDialog.filter(
        (x) => x.ItemNo !== item.ItemNo || x.seq !== item.seq
      );
      setItemDialog(i);
    } else {
      const i = itemDialog.map((x) => {
        x.lots = x.lots.filter((y) => y.Lot !== lot.Lot);
        return x;
      });
      setItemDialog(i);
    }
  };
  const CheckShowSelectDiscount = () => {
    // const customerType = this.customerSelected?.CustomerTypeNo?.CustomerTypeNo;

    return (
      SaleType !== "ราคาโครงการพิเศษ" &&
      ((customerData?.CustomerTypeNo?.CustomerTypeNo === "CT01" &&
        PaymentType === "จัดทำแปลง") ||
        (customerData?.CustomerTypeNo?.CustomerTypeNo === "CT02" &&
          PaymentType === "ขายสด")) &&
      tabSelected !== "ขายเฉพาะกิจ" &&
      !itemDialog?.some((e) => e.Option2?.includes("หลัก"))
    );
  };

  const ChangeTab = (event) => {
    if (event === "ขายเมล็ดพันธุ์") {
      setItemDialog([]);
      setSaleType("ราคาปกติ");
      setTabSelected("ขายเมล็ดพันธุ์");
      // this.form.get('noneDiscount').setValue(true);
      // this.form.get('noneDeliveryPrice').setValue(event.checked);
    }

    if (event === "สำรอง") {
      setItemDialog([]);
      setSaleType("ราคาปกติ");
      setTabSelected("สำรอง");
    }
    if (event === "ขายเฉพาะกิจ") {
      setItemDialog([]);
      setSaleType("ราคาเฉพาะกิจ");
      setTabSelected("ขายเฉพาะกิจ");
      // this.form.get('noneDiscount').setValue(event.checked);
      // this.form.get('noneDeliveryPrice').setValue(event.checked);
    }
    if (event === "ขายเมล็ดพันธุ์คัดออก") {
      setItemDialog([]);
      setSaleType("ราคาคัดออกใช้ประโยชน์ได้");
      setTabSelected("ขายเมล็ดพันธุ์คัดออก");
    }
  };

  const PaymentChange = (event) => {
    const paymentType = event;
    const customerTypeNo = customerData?.CustomerTypeNo?.CustomerTypeNo;

    if (SaleType) {
      if (SaleType === "ราคาโครงการพิเศษ") {
        setNoneDiscount(true);
        setNoneDeliveryPrice(false);
        setPaymentType(event);
      } else {
        setNoneDiscount(false);
        setNoneDeliveryPrice(false);
        setPaymentType(event);
        if (paymentType) {
          if (customerTypeNo === "CT02" && paymentType === "ขายสด") {
            setNoneDiscount(false);
            setNoneDeliveryPrice(false);
            setPaymentType(event);
          } else if (customerTypeNo === "CT02" && paymentType === "ขายเชื่อ") {
            setNoneDiscount(true);
            setNoneDeliveryPrice(false);
            setPaymentType(event);
          }
        }
      }
    }
  };

  const SaleTypeChange = (event) => {
    const saleType = event;
    const customerTypeNo = customerData?.CustomerTypeNo?.CustomerTypeNo;

    if (saleType) {
      if (saleType === "ราคาโครงการพิเศษ") {
        setNoneDiscount(true);
        setNoneDeliveryPrice(false);
        setSaleType(saleType);
      } else {
        setNoneDiscount(false);
        setNoneDeliveryPrice(false);
        setSaleType(saleType);

        if (PaymentType) {
          if (customerTypeNo === "CT02" && PaymentType === "ขายสด") {
            setNoneDiscount(false);
            setNoneDeliveryPrice(false);
            setSaleType(saleType);
          } else if (customerTypeNo === "CT02" && PaymentType === "ขายเชื่อ") {
            setNoneDiscount(true);
            setNoneDeliveryPrice(false);
            setSaleType(saleType);
          }
        }
      }
    }
  };

  async function submit() {
    const DoiDetails = [];
    // if (this.form.invalid) {

    //   return this.form.markAllAsTouched();
    // }

    if (itemDialog.length === 0) {
      Swal.fire({
        title: "กรุณาเลือกเมล็ดพันธุ์ที่ต้องการขาย",
        icon: "warning",
      });
    }

    // this.loading.submit = true;

    setLoadingSubmit(true);
    const delivery = {
      ContactName: undefined,
      DeliveryName: undefined,
      HouseNumber: HouseNumber,
      Moo: Moo,
      Address: Address,
      Province: Province,
      District: District,
      SubDistrict: SubDistrict,
      Zipcode: Zipcode,
      Tel: Tel,
      Fax: Fax,
    };

    for (const c of itemDialog) {
      for (const l of c.lots) {
        DoiDetails.push({
          ItemNo: c?.ItemNo,
          Lot: l?.Lot || null,
          Qty: +l?.Qty.toString().replaceAll(",", ""),
          UnitNo: l?.UnitNo?.UnitNo,
          SalePrice: l.SalePrice,
          ReserveNo: c?.ReserveNo ? c?.ReserveNo : undefined,
          WarehouseNo: l?.WarehouseNo?.WarehouseNo || l?.WarehouseNo,
          ReserveDetailCode: c?.ReserveDetailCode
            ? c?.ReserveDetailCode
            : undefined,
          ZoneNo: l?.ZoneNo?.ZoneNo || l?.ZoneNo,
          DiscountPromotion: undefined,
          DiscountGroup: undefined,
          PromotionNo: l?.PromotionNo ? l?.PromotionNo : undefined,
        });
      }
    }

    const body = {
      BranchNo: profile?.BranchNo?.BranchNo,
      CustomerNo: CustomerNo,
      Remark: Remark,
      DeliveryDocNo: DeliveryDocNo || undefined,
      DeliveryDocDate: DeliveryDocDate
        ? dayjs(DeliveryDocDate).format("YYYY-MM-DD")
        : undefined,
      InspectionDocNo: InspectionDocNo || undefined,
      InspectionDocDate: InspectionDocDate
        ? dayjs(InspectionDocDate).format("YYYY-MM-DD")
        : undefined,
      SaleTotal: totalPrice(),
      SaleType: SaleType,
      PaymentType: PaymentType,
      PaymentRemark: PaymentType === "จัดทำแปลง" ? PaymentRemark : "",
      DiscountTotal: Discount(),
      IsCampaignReserved: null,
      DiscountPercent: discountPercent,
      DeliveryPrice: totalDelivery(),
      TotalAmount: totalPrice() + totalDelivery(),
      UseCustomerAddress: true,
      DoiDelivery: delivery,
      DoiDetails: DoiDetails,
    };
    const data = await addSaleDois(body);
    if (data.status === true) {
      setDoiNo(data.result.DoiNo);
      setLoadingSubmit(false);
      setOpenDownload(true);
      LoadStockItems();
    } else {
      Swal.fire({
        title: data?.message || "ทำรายการไม่สำเร็จ",
        icon: "warning",
      });
      setLoadingSubmit(false);
    }

    // this.ConfirmDialogSubmit(body, this.stockItemSelected);
    // const res = await this.saleService.PostSaleDoi(body);
    // if (res) {
    //   this.DoiNo = res?.DoiNo;
    //   await this.LoadStockItems();
    // }

    // this.loading.submit = false;

    setOpenSubmit(false);
  }

  // async function downloadFile() {
  //     setLoadingDownload(true)
  //     const newDoi = encodeURIComponent(DoiNo);
  //     const res = await api.get(SALE_CONFIG.requests.saleDoi.url + `/${newDoi}/pdf`, {
  //         responseType: 'arraybuffer'
  //     })
  //     const data = res.data

  //     const blob = new Blob([data], { type: 'application/pdf' });
  //     // saveAs(blob, file?.FileName);
  //     const url = window.URL.createObjectURL(blob);
  //     window.open(url, '_blank');
  //     setLoadingDownload(false)
  // }
  async function downloadFile() {
    setLoadingDownload(true);
    const newDoi = encodeURIComponent(DoiNo);
    const res = await api.get("sale/receipts" + `/${newDoi}/pdf`, {
      responseType: "arraybuffer",
    });
    const data = res.data;

    const blob = new Blob([data], { type: "application/pdf" });
    // saveAs(blob, file?.FileName);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    setLoadingDownload(false);
  }
  async function downloadFileDoi() {
    setLoadingDownloadDoi(true);
    const newDoi = encodeURIComponent(DoiNo);
    const res = await api.get(
      SALE_CONFIG.requests.saleDoi.url + `/${newDoi}/pdf`,
      {
        responseType: "arraybuffer",
      }
    );
    const data = res.data;

    const blob = new Blob([data], { type: "application/pdf" });
    // saveAs(blob, file?.FileName);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    setLoadingDownloadDoi(false);
  }
  function clearValue() {
    setItemDialog([]);
    setStockReserveItems([]);
    setFilterReserveItems([]);
    setStockNormalItem([]);
    setStockPromotionItems([]);
    setCustomerData();
    setReserveNo("all");
    setDeliveryDocNo("");
    setDeliveryDocDate();
    setInspectionDocNo("");
    setInspectionDocDate();
    setCustomerText("");
    setCustomerTypeName();
  }
  const Balance = (z) => {
    let total = 0;

    const filter = itemDialog?.filter((x) => x?.ItemNo === z?.ItemNo) || [];
    filter.forEach((x) => {
      total += x?.lots
        ?.map((x) => +x.Qty?.toString().replaceAll(",", ""))
        .reduce((p, n) => +p + +n, 0);
    });

    return filter.length > 0 ? +z?.Balance - total : z?.Balance;
  };

  function searchChange() {
    if (tabSelected === "ขายเมล็ดพันธุ์") {
      let stockItems = [];
      stockItems = filterNormalItem.filter(
        (x) =>
          x.ItemName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.CatalogNo?.CatalogName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.GroupNo?.GroupName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option2.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option1.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Season.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Chemical.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1
      );
      setStockNormalItem(stockItems);
    } else if (tabSelected === "สำรอง") {
      let ReserveItems = [];
      ReserveItems = filterReserveItems.filter(
        (x) =>
          x.ItemName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.CatalogNo?.CatalogName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.GroupNo?.GroupName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option2.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option1.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Season.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Chemical.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1
      );
      setStockReserveItems(ReserveItems);
    } else if (tabSelected === "ขายเฉพาะกิจ") {
      let PromotionItems = [];
      PromotionItems = filterPromotionItems.filter(
        (x) =>
          x.ItemName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.CatalogNo?.CatalogName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.GroupNo?.GroupName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option2.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Option1.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Season.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.Chemical.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1
      );
      setStockPromotionItems(PromotionItems);
    } else if (tabSelected === "ขายเมล็ดพันธุ์คัดออก") {
      let DiscardItems = [];
      DiscardItems = filterStockDiscardItems.filter(
        (x) =>
          x.ItemNo.ItemName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.CatalogNo?.CatalogName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.GroupNo?.GroupName.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.Option2.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.Option1.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.Season.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1 ||
          x.ItemNo.Chemical.toLocaleLowerCase().indexOf(
            keyword ? keyword.toLowerCase() : ""
          ) > -1
      );
      setStockDiscardItems(DiscardItems);
    }
  }
  useEffect(() => {
    searchChange();
  }, [keyword]);
  const onBlurD = (e) => {
    if (!e.target.value) {
      setDeliveryDocDateError(true);
    } else {
      setDeliveryDocDateError(false);
    }
  };
  const onBlurI = (e) => {
    if (!e.target.value) {
      setInspectionDocDateError(true);
    } else {
      setInspectionDocDateError(false);
    }
  };
  return (
    <div>
      <form>
        <div class="card-content mt-4">
          <div class="container-fluid">
            <div class="d-flex row align-items-center ">
              <div class="col-12">
                <label class="title-content mb-4 me-4">ขายเมล็ดพันธุ์</label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">
                  ชื่อ-สกุลลูกค้า/เลขบัตรประจำตัวประชาชน
                </label>
                <Autocomplete
                  options={customers || []}
                  componentsProps={{
                    paper: {
                      sx: {
                        width: 900,
                      },
                    },
                  }}
                  onBlur={(e) => {
                    if (!customerData) {
                      setCustomerError(true);
                    } else {
                      setCustomerError(false);
                    }
                  }}
                  getOptionLabel={(option) =>
                    `( ${option?.CustomerNo} ) ${option?.ContactName}||~~${option?.NationalityId}`
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.CustomerNo}>
                      ({option?.CustomerNo}) {option?.ContactName} (
                      {option?.CustomerTypeNo?.TypeName}) / บัตรประจำตัวประชาชน
                      : {option?.NationalityId}{" "}
                    </Box>
                  )}
                  inputValue={customerText || ""}
                  onInputChange={(event, newInputValue) => {
                    setCustomerText(newInputValue);
                  }}
                  value={customerData}
                  onChange={(event, newValue) => {
                    newValue.NationalityId = "";
                    setCustomerData(newValue);
                    // setCustomerTypeName(newValue.CustomerTypeNo.TypeName)
                    // setAddress(`บ้านเลขที่ ${newValue?.HouseNumber} หมู่ที่ ${newValue?.Moo || '-'} ตำบล ${newValue?.SubDistrict} อำเภอ ${newValue?.District} จังหวัด ${newValue?.Province}`)
                    LoadStockItems();
                    // LoadStockDiscardItems()
                    const getNewReserveCustomer = async () => {
                      const res = await getReserveCustomer(
                        newValue?.CustomerNo
                      );
                      setReserveCustomer(res);
                    };
                    getNewReserveCustomer();
                    setStockReserveItems([]);
                    setFilterReserveItems([]);
                    setItemDialog([]);
                    setReserveNo("all");
                    const customer = newValue;
                    const customerName = `(${customer?.CustomerNo}) ${customer?.ContactName}`;
                    const Province = customer?.Province;
                    const District = customer?.District;
                    const SubDistrict = customer?.SubDistrict;
                    const Zipcode = customer?.Zipcode;
                    const Moo = customer?.Moo ? `หมู่ ${customer?.Moo}` : "";
                    const Address = customer?.Address
                      ? `ถนน${customer?.Address}`
                      : "";
                    const HouseNumber = customer?.HouseNumber
                      ? `บ้านเลขที่ ${customer?.HouseNumber}`
                      : "";
                    const Alley = customer?.Alley
                      ? `ซอย ${customer?.Alley}`
                      : "";
                    const AddressNational = `${HouseNumber} ${Moo} ${Alley} ${Address} ตำบล${SubDistrict} อำเภอ${District} จังหวัด${Province} ${Zipcode}`;
                    setTabSelected("ขายเมล็ดพันธุ์");
                    setSaleType("ราคาปกติ");
                    if (
                      customer?.CustomerTypeNo?.CustomerTypeNo !== "CT00" &&
                      customer?.CustomerTypeNo?.CustomerTypeNo !== "CT01"
                    ) {
                      setNoneDiscount(false);
                      setNoneDeliveryPrice(false);
                      setPaymentType("ขายสด");
                    }
                    if (customer?.CustomerTypeNo?.CustomerTypeNo === "CT00") {
                      setNoneDiscount(true);
                      setNoneDeliveryPrice(true);
                      setPaymentType("ขายเชื่อ");
                      setTabSelected("สำรอง");
                    }

                    if (customer?.CustomerTypeNo?.CustomerTypeNo === "CT01") {
                      setNoneDiscount(false);
                      setNoneDeliveryPrice(false);
                      setPaymentType("จัดทำแปลง");
                    }

                    ////////////////////////////////////////

                    setCustomerName(customerName);
                    setCustomerNo(customer?.CustomerNo);
                    setCustomerTypeName(customer?.CustomerTypeNo?.TypeName);
                    setProvince(customer?.Province);
                    setDistrict(customer?.District);
                    setSubDistrict(customer?.SubDistrict);
                    setZipcode(customer?.Zipcode);
                    setTel(customer?.Tel);
                    setFax(customer?.Fax);
                    setMoo(customer?.Moo);
                    setAddress(customer?.Address);
                    setHouseNumber(customer?.HouseNumber);
                    setAddressNational(AddressNational);

                    setDeliveryDocNo("");
                    setDeliveryDocDate();
                    setInspectionDocNo("");
                    setInspectionDocDate();

                    // this.form.get('DeliveryDocNo').reset();
                    // this.form.get('DeliveryDocDate').reset();
                    // this.form.get('InspectionDocNo').reset();
                    // this.form.get('InspectionDocDate').reset();

                    // if (customer?.CustomerTypeNo?.CustomerTypeNo === 'CT00') {
                    //     this.form.get('DeliveryDocNo').setValidators(Validators.required);
                    //     this.form.get('DeliveryDocDate').setValidators(Validators.required);
                    //     this.form.get('InspectionDocNo').setValidators(Validators.required);
                    //     this.form.get('InspectionDocDate').setValidators(Validators.required);

                    // } else {
                    //     this.form.get('DeliveryDocNo').clearValidators();
                    //     this.form.get('DeliveryDocDate').clearValidators();
                    //     this.form.get('InspectionDocNo').clearValidators();
                    //     this.form.get('InspectionDocDate').clearValidators();
                    // }

                    // this.form.get("DeliveryDocNo").updateValueAndValidity({
                    //     // onlySelf: true
                    // });
                    // this.form.get("DeliveryDocDate").updateValueAndValidity({
                    //     // onlySelf: true
                    // });
                    // this.form.get("InspectionDocNo").updateValueAndValidity({
                    //     // onlySelf: true
                    // });
                    // this.form.get("InspectionDocDate").updateValueAndValidity({
                    //     // onlySelf: true
                    // });
                  }}
                  renderInput={(params) => {
                    const { value, ...remain } = params.inputProps;

                    return (
                      <Box
                        className={`backgroundField ${
                          customerError ? "error" : ""
                        }`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          value={value.split("||~~")[0]}
                          placeholder="ค้นหาลูกค้า"
                          type="text"
                          {...remain}
                          disableUnderline
                        />
                      </Box>
                    );
                  }}
                />
                {customerError && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกลูกค้า
                  </span>
                )}
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">กลุ่มลูกค้า</label>
                <Box className="backgroundField">
                  <TextField
                    disabled
                    value={CustomerTypeName}
                    onChange={(e) => setCustomerTypeName(e.target.value)}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">เลขที่ใบสำรอง</label>
                <Box className="backgroundField" sx={{ marginBottom: "20px" }}>
                  <FormControl variant="standard" fullWidth>
                    <Select
                      value={ReserveNo || ""}
                      defaultValue={"all"}
                      onChange={(e) => {
                        setReserveNo(e.target.value);
                        LoadItemsReserve(e.target.value);
                        // console.log(ReserveCustomer.find((item) => item.ReserveNo === e.target.value));
                        const item = ReserveCustomer.find(
                          (item) => item.ReserveNo === e.target.value
                        );
                        setDeliveryDocDate(
                          item?.DeliveryDocDate
                            ? dayjs(item?.DeliveryDocDate)
                            : null
                        );
                        setInspectionDocDate(
                          item?.InspectionDocDate
                            ? dayjs(item?.InspectionDocDate)
                            : null
                        );
                        setDeliveryDocNo(item?.DeliveryDocNo || "");
                        setInspectionDocNo(item?.InspectionDocNo || "");
                        setCheckedDeliveryDocDate(
                          item?.DeliveryDocDate ? true : false
                        );
                        setCheckedDeliveryDocNo(
                          item?.InspectionDocNo ? true : false
                        );
                        setCheckedInspectionDocNo(
                          item?.InspectionDocNo ? true : false
                        );
                        setCheckedInspectionDocDate(
                          item?.InspectionDocDate ? true : false
                        );
                      }}
                      disableUnderline
                    >
                      <MenuItem value="all" disabled>
                        เลือกใบสำรอง
                      </MenuItem>
                      {ReserveCustomer?.map((x) => (
                        <MenuItem value={x?.ReserveNo}>{`${x?.RefNo}${
                          x?.Province ? " " + x?.Province : ""
                        }${x?.District ? " " + x?.District : ""}`}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>

              <div class="col-md-12">
                <label class="labelInput">หมายเหตุ</label>
                <Box
                  className="backgroundField"
                  sx={{ marginBottom: "20px", borderRadius: "25px" }}
                >
                  <TextField
                    value={Remark}
                    onChange={(e) => setRemark(e.target.value)}
                    variant="standard"
                    fullWidth
                    multiline
                    rows={4}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-md-12">
                <label class="labelInput">ที่อยู่ตามบัตรประชาชน</label>
                <Box
                  className="backgroundField"
                  sx={{ marginBottom: "20px", borderRadius: "25px" }}
                >
                  <TextField
                    value={AddressNational}
                    disabled
                    variant="standard"
                    fullWidth
                    multiline
                    rows={4}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            {customerData?.CustomerTypeNo?.CustomerTypeNo === "CT00" && (
              <>
                <div class="row">
                  <div
                    class="col-lg-4 col-md-12"
                    style={{ marginBottom: "20px", borderRadius: "25px" }}
                  >
                    <label class="labelInput">เลขที่หนังสือบัญชีจัดส่ง</label>

                    <Box
                      className={`backgroundField ${
                        DeliveryDocNoError ? "error" : ""
                      }`}
                    >
                      <TextField
                        disabled={checkedDeliveryDocNo}
                        value={DeliveryDocNo}
                        onChange={(e) => setDeliveryDocNo(e.target.value)}
                        variant="standard"
                        fullWidth
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setDeliveryDocNoError(true);
                          } else {
                            setDeliveryDocNoError(false);
                          }
                        }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                    {DeliveryDocNoError && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        กรุณากรอกเลขที่หนังสือบัญชีจัดส่ง
                      </span>
                    )}
                  </div>
                  <div
                    class="col-lg-4 col-md-12"
                    style={{ marginBottom: "20px", borderRadius: "25px" }}
                  >
                    <label class="labelInput">ลงวันที่ (บัญชีจัดส่ง)</label>

                    <Box
                      className={`backgroundField ${
                        DeliveryDocDateError ? "error" : ""
                      }`}
                    >
                      <MobileDatePicker
                        disabled={checkedDeliveryDocDate}
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={DeliveryDocDate || null}
                        onChange={(e) => setDeliveryDocDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: DeliveryDocDate || null,
                            onBlur: onBlurD,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                    {DeliveryDocDateError && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        กรุณาเลือกวันที่
                      </span>
                    )}
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-4 col-md-12"
                    style={{ marginBottom: "20px", borderRadius: "25px" }}
                  >
                    <label class="labelInput">เลขที่คำสั่งกรมการข้าว</label>ฃ
                    {console.log(checkedInspectionDocNo)}
                    <Box
                      className={`backgroundField ${
                        InspectionDocNoError ? "error" : ""
                      }`}
                    >
                      <TextField
                        disabled={checkedInspectionDocNo}
                        value={InspectionDocNo}
                        onChange={(e) => setInspectionDocNo(e.target.value)}
                        variant="standard"
                        fullWidth
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setInspectionDocNoError(true);
                          } else {
                            setInspectionDocNoError(false);
                          }
                        }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                    {InspectionDocNoError && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        กรุณากรอกเลขที่คำสั่งกรมการข้าว
                      </span>
                    )}
                  </div>
                  <div
                    class="col-lg-4 col-md-12"
                    style={{ marginBottom: "20px", borderRadius: "25px" }}
                  >
                    <label class="labelInput">ลงวันที่ (คำสั่ง)</label>
                    <Box
                      className={`backgroundField ${
                        InspectionDocDateError ? "error" : ""
                      }`}
                    >
                      <MobileDatePicker
                        disabled={checkedInspectionDocDate}
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={InspectionDocDate || null}
                        onChange={(e) => setInspectionDocDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: InspectionDocDate || null,
                            onBlur: onBlurI,
                          },
                        }}
                        slots={{
                          textField: BrowserInput,
                        }}
                      />
                    </Box>
                    {InspectionDocDateError && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        กรุณาเลือกวันที่
                      </span>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {customerData && (
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="card-content mt-4">
                <div class="container-fluid">
                  <div class="d-flex row align-items-center ">
                    <div class="col-12">
                      <label class="title-content mb-4 me-4">
                        รายการขายสินค้า
                      </label>

                      <Box className="backgroundField">
                        <TextField
                          variant="standard"
                          fullWidth
                          placeholder="ค้นหา เมล็ดพันธ์ุ"
                          value={keyword}
                          onChange={(e) => setkeyword(e.target.value)}
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <Box sx={{ marginRight: "10px" }}>
                                <FontAwesomeIcon icon={faSearch} />
                              </Box>
                            ),
                          }}
                        />
                      </Box>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-4">
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          value={tabSelected}
                          onChange={(event, newValue) => ChangeTab(newValue)}
                          sx={{
                            width: "100%",
                            ".MuiTabs-indicator": {
                              background: "#ffa101",
                            },
                          }}
                        >
                          {customerData?.CustomerTypeNo?.CustomerTypeNo !==
                            "CT00" && (
                            <Tab
                              value="ขายเมล็ดพันธุ์"
                              label="ขายเมล็ดพันธุ์"
                              sx={{
                                fontSize: "1rem",
                                "&.Mui-selected": {
                                  color: "#000",
                                },
                              }}
                            />
                          )}

                          <Tab
                            value="สำรอง"
                            label="สำรอง"
                            sx={{
                              fontSize: "1rem",
                              "&.Mui-selected": {
                                color: "#000",
                              },
                            }}
                          />
                          {customerData?.CustomerTypeNo?.CustomerTypeNo !==
                            "CT00" && (
                            <Tab
                              value="ขายเฉพาะกิจ"
                              label="ขายเฉพาะกิจ"
                              sx={{
                                fontSize: "1rem",
                                "&.Mui-selected": {
                                  color: "#000",
                                },
                              }}
                            />
                          )}
                          <Tab
                            value="ขายเมล็ดพันธุ์คัดออก"
                            label="ขายเมล็ดพันธุ์คัดออก"
                            sx={{
                              fontSize: "1rem",
                              "&.Mui-selected": {
                                color: "#000",
                              },
                            }}
                          />
                        </Tabs>
                        <TabPanel value={tabSelected} index="ขายเมล็ดพันธุ์">
                          {stockNormalItem
                            ?.filter((y) => y?.Status === "Y")
                            ?.map((x) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "30px",
                                  marginBottom: "10px",
                                  boxShadow:
                                    "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                                }}
                              >
                                <div>
                                  <h6>
                                    {x?.ItemName} {x?.Option2}{" "}
                                    <span
                                      style={{
                                        color:
                                          x?.Season === "ฝน"
                                            ? "#0D9206"
                                            : "brown",
                                      }}
                                    >
                                      {" "}
                                      {x?.Season}
                                    </span>{" "}
                                    {x?.Option1} {x?.Chemical}
                                  </h6>
                                  {/* <p style={{ marginBottom: "0" }}>{`ราคา ${x?.SalePrice} บาท`}</p>
                                                        <p>{`ปริมาณคงเหลือในโรงเก็บ ${x?.Balance} กิโลกรัม`}</p> */}
                                  <div
                                    style={{ width: "90%", color: "#0D9206" }}
                                    class="mt-2"
                                  >
                                    ราคา{" "}
                                    {parseFloat(x?.SalePrice)
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                                    บาท
                                  </div>
                                  <div style={{ width: "90%" }} class="mt-2">
                                    <span style={{ color: "#FFA101" }}>
                                      ปริมาณคงเหลือในโรงเก็บ{" "}
                                      {Balance(x).toLocaleString()} กิโลกรัม
                                    </span>
                                  </div>
                                </div>
                                <Button
                                  variant="contained"
                                  onClick={() => selectedItem(x)}
                                >
                                  เลือก
                                </Button>
                              </Box>
                            ))}
                        </TabPanel>
                        <TabPanel value={tabSelected} index="สำรอง">
                          {stockReserveItems?.map((x) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px",
                                marginBottom: "10px",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                              }}
                            >
                              <div>
                                <h6>
                                  {x?.ItemName} {x?.Option2}{" "}
                                  <span
                                    style={{
                                      color:
                                        x?.Season === "ฝน"
                                          ? "#0D9206"
                                          : "brown",
                                    }}
                                  >
                                    {" "}
                                    {x?.Season}
                                  </span>{" "}
                                  {x?.Option1} {x?.Chemical}
                                </h6>
                                {/* <p style={{ marginBottom: "0" }}>{`ราคา ${x?.SalePrice} บาท`}</p>
                                                        <p>{`ปริมาณคงเหลือในโรงเก็บ ${x?.Balance} กิโลกรัม`}</p> */}
                                <div
                                  style={{ width: "90%", color: "#0D9206" }}
                                  class="mt-2"
                                >
                                  ราคา{" "}
                                  {parseFloat(x?.SalePrice)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                                  บาท
                                </div>
                                <div style={{ width: "90%" }} class="mt-2">
                                  <span style={{ color: "#FFA101" }}>
                                    ปริมาณคงเหลือในโรงเก็บ{" "}
                                    {Balance(x).toLocaleString()} กิโลกรัม
                                  </span>
                                </div>
                                <div style={{ width: "90%" }} class="mt-2">
                                  <span style={{ color: "#0D9206" }}>
                                    ยอดสำรอง {x?.ReservedQty.toLocaleString()}{" "}
                                    กิโลกรัม
                                  </span>
                                </div>
                                {x?.SubDistrict && (
                                  <div style={{ width: "90%" }} class="mt-2">
                                    <span style={{ color: "#291699" }}>
                                      ตำบล{x?.SubDistrict}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <Button
                                variant="contained"
                                onClick={() => selectedItem(x)}
                              >
                                เลือก
                              </Button>
                            </Box>
                          ))}
                        </TabPanel>
                        <TabPanel value={tabSelected} index="ขายเฉพาะกิจ">
                          {stockPromotionItems?.map((x) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px",
                                marginBottom: "10px",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                              }}
                            >
                              <div>
                                <h6>
                                  {x?.ItemName} {x?.Option2}{" "}
                                  <span
                                    style={{
                                      color:
                                        x?.Season === "ฝน"
                                          ? "#0D9206"
                                          : "brown",
                                    }}
                                  >
                                    {" "}
                                    {x?.Season}
                                  </span>{" "}
                                  {x?.Option1} {x?.Chemical}
                                </h6>
                                {/* <p style={{ marginBottom: "0" }}>{`ราคา ${x?.SalePrice} บาท`}</p>
                                                        <p>{`ปริมาณคงเหลือในโรงเก็บ ${x?.Balance} กิโลกรัม`}</p> */}
                                <div
                                  style={{ width: "90%", color: "#0D9206" }}
                                  class="mt-2"
                                >
                                  ราคา{" "}
                                  {parseFloat(x?.SalePrice)
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                                  บาท
                                </div>
                                <div style={{ width: "90%" }} class="mt-2">
                                  <span style={{ color: "#FFA101" }}>
                                    ปริมาณคงเหลือในโรงเก็บ{" "}
                                    {Balance(x).toLocaleString()} กิโลกรัม
                                  </span>
                                </div>
                              </div>
                              <Button
                                variant="contained"
                                onClick={() => selectedItem(x)}
                              >
                                เลือก
                              </Button>
                            </Box>
                          ))}
                        </TabPanel>
                        <TabPanel
                          value={tabSelected}
                          index="ขายเมล็ดพันธุ์คัดออก"
                        >
                          {StockDiscardItems?.map((x) => (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "20px 10px",
                                marginBottom: "10px",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                              }}
                            >
                              <div>
                                <h6>
                                  {x?.ItemNo?.ItemName} {x?.ItemNo?.Option2}{" "}
                                  <span
                                    style={{
                                      color:
                                        x?.Season === "ฝน"
                                          ? "#0D9206"
                                          : "brown",
                                    }}
                                  >
                                    {" "}
                                    {x?.Season}
                                  </span>{" "}
                                  {x?.ItemNo?.Option1}
                                </h6>
                                {/* <p style={{ marginBottom: "0" }}>{`ราคา ${x?.SalePrice} บาท`}</p>
                                                        <p>{`ปริมาณคงเหลือในโรงเก็บ ${x?.Balance} กิโลกรัม`}</p> */}

                                <div style={{ width: "100%" }} class="mt-2">
                                  <span style={{ color: "#FFA101" }}>
                                    ปริมาณคงเหลือในโรงเก็บ{" "}
                                    {Balance(x)?.toLocaleString()} กิโลกรัม
                                  </span>
                                </div>
                              </div>
                              <Button
                                variant="contained"
                                onClick={() => handleClickOpen(x)}
                              >
                                เลือก
                              </Button>
                            </Box>
                          ))}
                        </TabPanel>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card-content mt-4">
                <div class="container-fluid">
                  <div class="d-flex row align-items-center ">
                    <div class="col-12">
                      <label class="title-content mb-4 me-4">
                        รายการที่เลือก
                      </label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div>รายการเมล็ดพันธุ์ที่เลือก</div>
                    <div>ราคา</div>
                  </div>
                  {itemDialog.length > 0 && <hr class="chs" />}
                  {itemDialog?.map((x) => (
                    <div class="row d-flex align-items-center mt-4 mb-3">
                      <div class="col-8">
                        <div class="item-name">
                          <h6>
                            {x?.ItemName} {x?.Option2}{" "}
                            <span
                              style={{
                                color: x?.Season === "ฝน" ? "#0D9206" : "brown",
                              }}
                            >
                              {" "}
                              {x?.Season}
                            </span>{" "}
                            {x?.Option1}{" "}
                            {tabSelected !== "ขายเมล็ดพันธุ์คัดออก" &&
                              x?.Chemical}
                          </h6>
                        </div>
                        {x?.lots?.map((z) => (
                          <div class="row" style={{ display: "flex" }}>
                            <div style={{ width: "40%", color: "gray" }}>
                              Lot : {z?.Lot || "ทั้งหมด"}
                            </div>
                            <div style={{ width: "40%", color: "gray" }}>
                              x {z?.Qty?.toLocaleString()} กิโลกรัม
                            </div>

                            <div
                              class="del"
                              style={{ width: "20%" }}
                              onClick={() => deleteLots(x, z)}
                            >
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                }}
                              >
                                x
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div class="col-4 text-end">
                        {parseFloat(totalQty(x))
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        <div> บาท</div>
                      </div>
                    </div>
                  ))}
                  <hr class="chs" />
                  <div class="d-flex justify-content-between">
                    <div>รวมเป็นเงิน</div>
                    <div>
                      {parseFloat(totalPrice())
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                      บาท
                    </div>
                  </div>
                  <hr class="chs" />
                  {tabSelected !== "ขายเมล็ดพันธุ์คัดออก" && (
                    <>
                      <div
                        class="d-flex justify-content-between"
                        style={{ alignItems: "center" }}
                      >
                        <div class="d-flex align-items-center">
                          <span class="me-3">
                            ส่วนลด
                            {Discount() > 0 ? (
                              <span style={{ color: "red", marginLeft: "5px" }}>
                                {discountPercent || 0}%
                              </span>
                            ) : (
                              <span style={{ color: "red", marginLeft: "5px" }}>
                                0%
                              </span>
                            )}
                          </span>
                          {CheckShowSelectDiscount() && (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={noneDiscount}
                                  onChange={(e) =>
                                    setNoneDiscount(e.target.checked)
                                  }
                                />
                              }
                              label="ไม่คิดส่วนลด"
                              sx={{ color: "red" }}
                            />
                          )}
                        </div>

                        <div>
                          {parseFloat(Discount())
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                          บาท
                        </div>
                      </div>
                      <hr class="chs" />
                    </>
                  )}
                  <div
                    class="d-flex justify-content-between"
                    style={{ alignItems: "center" }}
                  >
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">ค่าขนส่งกิโลกรัมละ 1 บาท</span>
                        {customerData?.CustomerTypeNo?.CustomerTypeNo ===
                          "CT02" &&
                        PaymentType === "ขายเชื่อ" &&
                        SaleType !== "ราคาโครงการพิเศษ" ? (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={noneDeliveryPrice}
                                onChange={(e) =>
                                  setNoneDeliveryPrice(e.target.checked)
                                }
                              />
                            }
                            label="คิดค่าขนส่ง"
                            sx={{ color: "red" }}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div>
                      {parseFloat(totalDelivery())
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                      บาท
                    </div>
                  </div>
                  {/* <div>VAT</div>
                        <div>0 บาท</div> */}
                  <hr class="chs" />
                  <div class="d-flex align-items-center">
                    <div class="pe-3">ประเภทการขาย :</div>
                    <div>
                      <RadioGroup
                        row
                        value={SaleType}
                        onChange={(e) => SaleTypeChange(e.target.value)}
                      >
                        {" "}
                        {tabSelected === "ขายเฉพาะกิจ" ? (
                          <>
                            <FormControlLabel
                              value="ราคาเฉพาะกิจ"
                              control={<Radio />}
                              label="ราคาเฉพาะกิจ"
                            />
                            <FormControlLabel
                              value="ราคาขายทอดตลาด"
                              control={<Radio />}
                              label="ราคาขายทอดตลาด"
                            />
                          </>
                        ) : tabSelected === "ขายเมล็ดพันธุ์คัดออก" ? (
                          <FormControlLabel
                            value="ราคาคัดออกใช้ประโยชน์ได้"
                            control={<Radio />}
                            label="ราคาคัดออกใช้ประโยชน์ได้"
                          />
                        ) : tabSelected === "สำรอง" ? (
                          <>
                            <FormControlLabel
                              value="ราคาปกติ"
                              control={<Radio />}
                              label="ราคาปกติ"
                            />
                            <FormControlLabel
                              value="ราคาประสบภัย"
                              control={<Radio />}
                              label="ราคาประสบภัย"
                            />
                          </>
                        ) : (
                          <>
                            <FormControlLabel
                              value="ราคาปกติ"
                              control={<Radio />}
                              label="ราคาปกติ"
                            />
                            <FormControlLabel
                              value="ราคาโครงการพิเศษ"
                              control={<Radio />}
                              label="ราคาโครงการพิเศษ"
                            />
                          </>
                        )}
                      </RadioGroup>
                    </div>
                  </div>
                  <hr class="chs" />
                  <div class="d-flex align-items-center">
                    <div class="pe-3">ประเภทการจ่าย :</div>
                    <div>
                      <RadioGroup
                        row
                        value={PaymentType}
                        onChange={(e) => PaymentChange(e.target.value)}
                      >
                        {customerData?.CustomerTypeNo?.CustomerTypeNo !==
                          "CT00" &&
                        customerData?.CustomerTypeNo?.CustomerTypeNo !==
                          "CT01" ? (
                          <FormControlLabel
                            value="ขายสด"
                            control={<Radio />}
                            label="ขายสด"
                          />
                        ) : null}
                        {customerData?.CustomerTypeNo?.CustomerTypeNo ===
                          "CT00" ||
                        customerData?.CustomerTypeNo?.CustomerTypeNo ===
                          "CT02" ? (
                          <FormControlLabel
                            value="ขายเชื่อ"
                            control={<Radio />}
                            label="ขายเชื่อ"
                          />
                        ) : null}
                        {customerData?.CustomerTypeNo?.CustomerTypeNo ===
                        "CT01" ? (
                          <FormControlLabel
                            value="จัดทำแปลง"
                            control={<Radio />}
                            label="เพื่อจัดทำแปลงฤดู/ปี"
                          />
                        ) : null}
                      </RadioGroup>
                      {customerData?.CustomerTypeNo?.CustomerTypeNo ===
                      "CT01" ? (
                        <TextField
                          value={PaymentRemark}
                          onChange={(e) => setPaymentRemark(e.target.value)}
                          size="small"
                          placeholder=""
                          variant="outlined"
                          sx={{ width: "200px" }}
                        />
                      ) : null}
                    </div>

                    <div style={{ width: "20%" }}></div>
                  </div>
                  <hr class="chs" />
                  <div class="d-flex justify-content-between align-items-center">
                    <div>รวมเป็นเงินสุทธิ</div>
                    <div
                      style={{
                        color: "#3364AF",
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                      }}
                    >
                      {parseFloat(NetPrice())
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                      บาท
                    </div>
                  </div>
                  <hr class="chs" />
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div style={{ color: "red" }}>
                      ตรวจสอบรายการก่อนกดสั่งซื้อ
                    </div>
                  </div>
                  <div class="row">
                    {DoiNo && (
                      <>
                        <div class="col-md-6 col-sm-12">
                          <Button
                            onClick={() => downloadFileDoi()}
                            sx={{
                              width: "100% !important",
                              borderRadius: "5px",
                              backgroundColor: "#fbbe66",
                              border: "1px solid #fbbe66",
                              color: "#fff",
                              height: "40px !important",
                              ":hover": {
                                backgroundColor: "#fbbe66",
                                border: "1px solid #fbbe66",
                              },
                            }}
                          >
                            พิมพ์ใบ DOI
                          </Button>
                        </div>
                        <div class="col-md-6 col-sm-12">
                          <Button
                            onClick={() => window.location.reload()}
                            sx={{
                              width: "100% !important",
                              borderRadius: "5px",
                              backgroundColor: "#3364af",
                              border: "1px solid #3364af",
                              color: "#fff",
                              height: "40px !important",
                              ":hover": {
                                backgroundColor: "#3364af",
                                border: "1px solid #3364af",
                              },
                            }}
                          >
                            ทำรายการขายต่อ
                          </Button>
                        </div>
                      </>
                    )}
                    {!DoiNo && (
                      <div class="col-md-12 col-sm-12">
                        <Button
                          onClick={() => {
                            if (
                              customerData?.CustomerTypeNo?.CustomerTypeNo ===
                              "CT00"
                            ) {
                              if (!InspectionDocDate) {
                                setInspectionDocDateError(true);
                              }
                              if (InspectionDocNo.length === 0) {
                                setInspectionDocNoError(true);
                              }
                              if (!DeliveryDocDate) {
                                setDeliveryDocDateError(true);
                              }
                              if (DeliveryDocNo.length === 0) {
                                setDeliveryDocNoError(true);
                              }
                              if (
                                InspectionDocDate &&
                                DeliveryDocDate &&
                                InspectionDocNo.length > 0 &&
                                DeliveryDocNo.length > 0
                              ) {
                                if (itemDialog.length > 0) {
                                  setOpenSubmit(true);
                                } else {
                                  Swal.fire(
                                    "กรุณาเลือกเมล็ดพันธุ์ที่ต้องการขาย",
                                    "",
                                    "error"
                                  );
                                }
                              }
                            } else {
                              if (itemDialog.length > 0) {
                                setOpenSubmit(true);
                              } else {
                                Swal.fire(
                                  "กรุณาเลือกเมล็ดพันธุ์ที่ต้องการขาย",
                                  "",
                                  "error"
                                );
                              }
                            }
                          }}
                          sx={{
                            width: "100% !important",
                            borderRadius: "15px",
                            backgroundColor: "#3364af",
                            border: "1px solid #3364af",
                            color: "#fff",
                            height: "40px !important",
                            ":hover": {
                              backgroundColor: "#3364af",
                              border: "1px solid #3364af",
                            },
                          }}
                        >
                          สั่งซื้อ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ color: "#3364af", fontWeight: "600" }}
        >
          {`${dialogData?.item?.CatalogNo?.CatalogName} ${dialogData?.item?.Option2} ${dialogData?.item?.Season} ${dialogData?.item?.Option1} ${dialogData?.item?.Chemical}`}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              padding: "0px 16px 16px 16px",
            }}
          >
            <Box className="backgroundField">
              <TextField
                value={keyword2}
                variant="standard"
                onChange={(e) => {
                  setkeyword2(e.target.value);
                  let lots = [];
                  lots = dialogData?.lot?.filter(
                    (x) =>
                      x.Lot.toLocaleLowerCase().indexOf(
                        e.target.value ? e.target.value.toLowerCase() : ""
                      ) > -1
                  );
                  setDialogDatafilter({ ...dialogDatafilter, lot: lots });
                }}
                fullWidth
                placeholder="ค้นหา Lots"
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <Box sx={{ marginRight: "10px" }}>
                      <FontAwesomeIcon icon={faSearch} />
                    </Box>
                  ),
                }}
              />
            </Box>
          </Box>
          <Table sx={{ width: "100%" }} aria-label="customized table">
            <TableRow>
              <StyledTableCell sx={{ fontWeight: "600", fontSize: "1rem" }}>
                ล็อตเมล็ดพันธุ์
              </StyledTableCell>
              <StyledTableCell
                align="center"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                จำนวนวันที่อยู่ในคลัง
              </StyledTableCell>
              <StyledTableCell
                align="center"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                โรงเก็บ
              </StyledTableCell>
              <StyledTableCell
                align="center"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                คงคลัง (กิโลกรัม)
              </StyledTableCell>
              <StyledTableCell
                align="center"
                sx={{ fontWeight: "600", fontSize: "1rem" }}
              >
                จำหน่าย (กิโลกรัม)
              </StyledTableCell>
            </TableRow>

            {dialogDatafilter?.lot?.map((x, i) => (
              <TableRow>
                <StyledTableCell align="left">
                  <TextField
                    size="small"
                    value={x?.Lot}
                    placeholder=""
                    variant="outlined"
                    sx={{ width: "290px" }}
                  />
                </StyledTableCell>
                <StyledTableCell align="center">
                  {x?.DaysInStock} วัน
                </StyledTableCell>
                <StyledTableCell align="center">
                  {x?.WarehouseNo?.WarehouseName}/ {x?.ZoneNo?.ZoneName}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {((x?.Balance - +x?.Qty?.toString().replaceAll(",", "") ||
                    x?.Balance -
                      +Item?.find(
                        (y) =>
                          y?.Lot + y?.WarehouseNo?.WarehouseNo ===
                          x?.Lot + x?.WarehouseNo?.WarehouseNo
                      )
                        ?.Qty?.toString()
                        .replaceAll(",", "")) > 0
                    ? x?.Balance - x?.Qty ||
                      x?.Balance -
                        +Item?.find(
                          (y) =>
                            y?.Lot + y?.WarehouseNo?.WarehouseNo ===
                            x?.Lot + x?.WarehouseNo?.WarehouseNo
                        )
                          ?.Qty?.toString()
                          .replaceAll(",", "")
                    : 0
                  ).toLocaleString()}
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TextField
                    value={
                      (
                        x?.Qty ||
                        Item?.find(
                          (y) =>
                            y?.Lot +
                              y?.WarehouseNo?.WarehouseNo +
                              y?.ZoneNo?.ZoneNo ===
                            x?.Lot +
                              x?.WarehouseNo?.WarehouseNo +
                              x?.ZoneNo?.ZoneNo
                        )?.Qty
                      )?.toLocaleString() || ""
                    }
                    size="small"
                    placeholder=""
                    variant="outlined"
                    sx={{ width: "290px" }}
                    onChange={(e) => {
                      const item = dialogDatafilter?.lot?.map((v, index) => {
                        let newValue = e.target.value.replace(/,/g, "");
                        let abc = newValue.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        );
                        v.Qty =
                          v?.Lot +
                            v?.WarehouseNo?.WarehouseNo +
                            v?.ZoneNo?.ZoneNo ===
                          x?.Lot +
                            x?.WarehouseNo?.WarehouseNo +
                            x?.ZoneNo?.ZoneNo
                            ? abc
                            : v?.Qty;
                        return v;
                      });
                      setItem([...item.filter((x) => x.Qty)]);
                      setDialogData({ ...dialogData, lot: item });
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {(x?.Balance - +x?.Qty?.toString().replaceAll(",", "") ||
                    x?.Balance -
                      +Item?.find(
                        (y) =>
                          y?.Lot + y?.WarehouseNo?.WarehouseNo ===
                          x?.Lot + x?.WarehouseNo?.WarehouseNo
                      )
                        ?.Qty?.toString()
                        .replaceAll(",", "")) < 0 ? (
                    <span
                      style={{
                        color: "red",
                        position: "absolute",
                        bottom: "-5px",
                      }}
                    >
                      เกินจำนวนเมล็ดพันธุ์ที่มีอยู่ในโรงเก็บ
                    </span>
                  ) : (
                    ""
                  )}
                </StyledTableCell>
              </TableRow>
            ))}
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ padding: "8px 20px", fontSize: "1rem" }}
            onClick={() => {
              setOpen(false);
              setItem([]);
              setkeyword2("");
            }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="contained"
            sx={{ padding: "8px 20px", fontSize: "1rem" }}
            onClick={() => {
              const totalQty = Item.map(
                (x) => +x?.Qty?.toString().replaceAll(",", "") || 0
              ).reduce((p, n) => p + n, 0);

              if (
                Item.filter(
                  (x) => x?.Balance - +x.Qty.toString().replaceAll(",", "") < 0
                ).length > 0 ||
                Item.filter((x) => x.Qty).length === 0
              ) {
                Swal.fire("กรุณากรอกจำนวน", "", "error");
              } else {
                if (
                  dialogData.item?.reserveCenter &&
                  totalQty !== dialogData?.item?.ReservedQty
                ) {
                  Swal.fire("กรุณากรอกจำนวนให้ตรงตามที่สำรอง", "", "error");
                } else {
                  handleClose();
                }
              }
            }}
          >
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSubmit}
        onClose={handleCloseSubmit}
        fullWidth
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            color: "rgb(51, 100, 175)",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          ตรวจสอบรายการ
        </DialogTitle>
        <DialogContent>
          <div style={{ padding: "30px" }}>
            <div class="d-flex justify-content-between">
              <div>รายการเมล็ดพันธุ์ที่เลือก</div>
              <div>ราคา</div>
            </div>
            {itemDialog.length > 0 && <hr class="chs" />}
            {itemDialog?.map((x) => (
              <div class="row d-flex align-items-center mt-4 mb-3">
                <div class="col-8">
                  <div class="item-name">
                    <h6>
                      {x?.ItemName} {x?.Option2}{" "}
                      <span
                        style={{
                          color: x?.Season === "ฝน" ? "#0D9206" : "brown",
                        }}
                      >
                        {" "}
                        {x?.Season}
                      </span>{" "}
                      {x?.Option1}{" "}
                      {tabSelected !== "ขายเมล็ดพันธุ์คัดออก" && x?.Chemical}
                    </h6>
                  </div>
                  {x?.lots?.map((z) => (
                    <div class="row" style={{ display: "flex" }}>
                      <div style={{ width: "40%", color: "gray" }}>
                        Lot : {z?.Lot}
                      </div>
                      <div style={{ width: "40%", color: "gray" }}>
                        x {z?.Qty.toLocaleString()} กิโลกรัม
                      </div>
                    </div>
                  ))}
                </div>
                <div class="col-4 text-end">
                  {parseFloat(totalQty(x))
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                  <div> บาท</div>
                </div>
              </div>
            ))}
            <hr class="chs" />
            <div class="d-flex justify-content-between">
              <div>รวมเป็นเงิน</div>
              <div>
                {parseFloat(totalPrice())
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                บาท
              </div>
            </div>
            <hr class="chs" />

            <div
              class="d-flex justify-content-between"
              style={{ alignItems: "center" }}
            >
              <div class="d-flex align-items-center">
                <span class="me-3">
                  ส่วนลด
                  {Discount() > 0 ? (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {discountPercent || 0}%
                    </span>
                  ) : (
                    <span style={{ color: "red", marginLeft: "5px" }}>0%</span>
                  )}
                </span>
                {CheckShowSelectDiscount() && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled
                        checked={noneDiscount}
                        onChange={(e) => setNoneDiscount(e.target.checked)}
                      />
                    }
                    label="ไม่คิดส่วนลด"
                    sx={{ color: "red" }}
                  />
                )}
              </div>

              <div>
                {parseFloat(Discount())
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                บาท
              </div>
            </div>
            <hr class="chs" />
            <div
              class="d-flex justify-content-between"
              style={{ alignItems: "center" }}
            >
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <span class="me-3">ค่าขนส่งกิโลกรัมละ 1 บาท</span>
                  {customerData?.CustomerTypeNo?.CustomerTypeNo === "CT02" &&
                  PaymentType === "ขายเชื่อ" &&
                  SaleType !== "ราคาโครงการพิเศษ" ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled
                          checked={noneDeliveryPrice}
                          onChange={(e) =>
                            setNoneDeliveryPrice(e.target.checked)
                          }
                        />
                      }
                      label="คิดค่าขนส่ง"
                      sx={{ color: "red" }}
                    />
                  ) : null}
                </div>
              </div>
              <div>
                {parseFloat(totalDelivery())
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                บาท
              </div>
            </div>
            {/* <div>VAT</div>
                        <div>0 บาท</div> */}
            <hr class="chs" />
            <div class="d-flex align-items-center">
              <div class="pe-3">ประเภทการขาย :</div>
              <div>
                <RadioGroup
                  row
                  value={SaleType}
                  onChange={(e) => SaleTypeChange(e.target.value)}
                >
                  {" "}
                  {tabSelected === "ขายเฉพาะกิจ" ? (
                    <FormControlLabel
                      disabled
                      value="ราคาเฉพาะกิจ"
                      control={<Radio />}
                      label="ราคาเฉพาะกิจ"
                    />
                  ) : tabSelected === "ขายเมล็ดพันธุ์คัดออก" ? (
                    <FormControlLabel
                      disabled
                      value="ราคาคัดออกใช้ประโยชน์ได้"
                      control={<Radio />}
                      label="ราคาคัดออกใช้ประโยชน์ได้"
                    />
                  ) : tabSelected === "สำรอง" ? (
                    <>
                      <FormControlLabel
                        value="ราคาปกติ"
                        control={<Radio />}
                        label="ราคาปกติ"
                      />
                      <FormControlLabel
                        value="ราคาประสบภัย"
                        control={<Radio />}
                        label="ราคาประสบภัย"
                      />
                    </>
                  ) : (
                    <>
                      <FormControlLabel
                        disabled
                        value="ราคาปกติ"
                        control={<Radio />}
                        label="ราคาปกติ"
                      />
                      <FormControlLabel
                        disabled
                        value="ราคาโครงการพิเศษ"
                        control={<Radio />}
                        label="ราคาโครงการพิเศษ"
                      />
                    </>
                  )}
                </RadioGroup>
              </div>
            </div>
            <hr class="chs" />
            <div class="d-flex align-items-center">
              <div class="pe-3">ประเภทการจ่าย :</div>
              <div>
                <RadioGroup
                  row
                  value={PaymentType}
                  onChange={(e) => PaymentChange(e.target.value)}
                >
                  {customerData?.CustomerTypeNo?.CustomerTypeNo !== "CT00" &&
                  customerData?.CustomerTypeNo?.CustomerTypeNo !== "CT01" ? (
                    <FormControlLabel
                      disabled
                      value="ขายสด"
                      control={<Radio />}
                      label="ขายสด"
                    />
                  ) : null}
                  {customerData?.CustomerTypeNo?.CustomerTypeNo === "CT00" ||
                  customerData?.CustomerTypeNo?.CustomerTypeNo === "CT02" ? (
                    <FormControlLabel
                      disabled
                      value="ขายเชื่อ"
                      control={<Radio />}
                      label="ขายเชื่อ"
                    />
                  ) : null}
                  {customerData?.CustomerTypeNo?.CustomerTypeNo === "CT01" ? (
                    <FormControlLabel
                      disabled
                      value="จัดทำแปลง"
                      control={<Radio />}
                      label="เพื่อจัดทำแปลงฤดู/ปี"
                    />
                  ) : null}
                </RadioGroup>
                {customerData?.CustomerTypeNo?.CustomerTypeNo === "CT01" ? (
                  <TextField
                    disabled
                    value={PaymentRemark}
                    onChange={(e) => setPaymentRemark(e.target.value)}
                    size="small"
                    placeholder=""
                    variant="outlined"
                    sx={{ width: "200px" }}
                  />
                ) : null}
              </div>

              <div style={{ width: "20%" }}></div>
            </div>
            <hr class="chs" />
            <div class="d-flex justify-content-between align-items-center">
              <div>รวมเป็นเงินสุทธิ</div>
              <div
                style={{
                  color: "#3364AF",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {parseFloat(NetPrice())
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}{" "}
                บาท
              </div>
            </div>
            <hr class="chs" />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ padding: "8px 20px", fontSize: "1rem" }}
            onClick={handleCloseSubmit}
          >
            ยกเลิก
          </Button>
          <Button
            disabled={loadingSubmit}
            variant="contained"
            sx={{ padding: "8px 20px", fontSize: "1rem", width: "200px" }}
            onClick={() => submit()}
          >
            {loadingSubmit ? (
              <CircularProgress size={"24px"} color="inherit" />
            ) : (
              "ยืนยันการทำรายการ"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <DiscardDialog
        open={openDiscard}
        data={DiscardItems}
        handleClose={handleCloseOpen}
        itemDialog={itemDialog}
        setItemDialog={setItemDialog}
      />
      <ConfirmPrint
        DoiNo={DoiNo}
        openDownload={openDownload}
        setOpenDownload={setOpenDownload}
        loadingDownload={loadingDownload}
        loadingDownloadDoi={loadingDownloadDoi}
        downloadFile={downloadFile}
        downloadFileDoi={downloadFileDoi}
      />
    </div>
  );
}
